import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useRemote } from './api';
import { useApp } from './context';
import { PageTitle, LinkButton, LoadState, Empty } from './ui';
import { RequestItem } from './requests/RequestItem';

const RequestList = ({ remote, user }) => {
  if (remote.loading || remote.error) return <LoadState remote={remote} />;
  if (!remote.data?.length) return <Empty title="No quotation requests yet"
    text={user.role === 'supplier' ? 'Buyer requests for your products will appear here.' : 'Start with a product or upload your SKU list.'}
    to={user.role === 'buyer' ? '/catalog' : undefined} label="Explore products" />;
  return <div className="request-list">{remote.data.map(rfq =>
    <RequestItem key={rfq.id} rfq={rfq} user={user} reload={remote.reload} />)}</div>;
};

export default function Requests() {
  const { user } = useApp();
  const remote = useRemote('/rfqs');
  return <>
    <PageTitle eyebrow="FROM REQUIREMENT TO OPPORTUNITY" title={user.role === 'supplier' ? 'Incoming requests.' : 'Your quotation requests.'}
      action={user.role === 'buyer' && <LinkButton to="/rfq" id="new-rfq">New request<ArrowUpRight size={16} /></LinkButton>}>
      Every sourcing conversation, in one place.
    </PageTitle>
    <RequestList remote={remote} user={user} />
  </>;
}